/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SpanishInputs */

const en_common_spanish = /** @type {(inputs: Common_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanish`)
};

const es_common_spanish = /** @type {(inputs: Common_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español`)
};

/**
* | output |
* | --- |
* | "Spanish" |
*
* @param {Common_SpanishInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_spanish = /** @type {((inputs?: Common_SpanishInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SpanishInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_spanish(inputs)
	return en_common_spanish(inputs)
});